export interface AISearchCountResponse {
    totalIdentified: number;
    totalShortlisted: number;
}

export const DefaultAISearchCountResponse: AISearchCountResponse = {
    totalIdentified: 0,
    totalShortlisted: 0,
};
